<template>
  <div class="payments" v-if="payments_show">
    <h5 class="payments__title">Metodi di pagamento</h5>
    <div class="payments__wrap">
      <div class="payments__item" v-for="(payment, index) in visible_payments" :key="`payment_${index}`">
        <span class="payments__name">
          <template v-if="payment.type === 'points'">Valore</template>
          {{ payment.name }}
        </span>
        <strong class="payments__value">
          <span v-if="payment.type !== 'points'"> € </span>
          {{ payment.value }}
        </strong>
      </div>
    </div>
    <div class="payments__blocked" v-if="credit_insufficient">
      <div class="payments__blocked-label">
        <span>Credito non sufficiente?</span>
        <vb-icon
          class="ml-1"
          :name="'vb-chat'"
          :color="sass('info')"
          :size="18"
        />
      </div>
      <p class="payments__blocked-text">
        Il tuo credito non è sufficiente a coprire il costo del pacchetto viaggio.
        Cerca un altro prodotto o <a href="javascript:window.zE.activate()">contattaci</a> per maggiori informazioni.
      </p>
    </div>
  </div>
</template>

<script>
import {
  calculate_payments_sum,
  should_show_payments,
  is_credit_insufficient,
  get_visible_payments,
} from './logic'

export default {
  name: 'payments',

  props: {
    live_price: String,
    payments: {
      type: Array,
      default: () => []
    }
  },

  computed: {
    payments_sum() {
      return calculate_payments_sum(this.payments)
    },

    payments_show() {
      return should_show_payments(this.payments)
    },

    credit_insufficient() {
      return is_credit_insufficient(this.live_price, this.payments_sum)
    },

    visible_payments() {
      return get_visible_payments(this.payments)
    },
  },
}
</script>

<style lang="scss" scoped>

  .payments {
    font-size: $font-size-md;

    &__title {
      @extend %sidebar__title;
    }

    &__item {
      display: flex;
      justify-content: space-between;
      margin-bottom: $grid-gutter-width/10;

      &:last-child {
        margin-bottom: 0;
      }
    }

    &__nocredit {
      margin-top: $grid-gutter-width/2;

      &__label {
        color: $secondary;
        font-weight: $vb-font-weight-semibold;
        display: flex;
        align-items: baseline;
        margin-bottom: $grid-gutter-width/6;
      }

      &__text {
        @include media-breakpoint-up(xl) {
          font-size: $font-size-sm;
        }
      }
    }
  }
</style>